module.exports = __webpack_public_path__ + "img/check.982ad5cb.svg";